module.exports = __webpack_public_path__ + "static/media/instagramreward.2b0f5cbf.svg";